import { useAuthStore } from '~/stores/auth'
import { useSessionStore } from '~/stores/session'
import type { User } from '~/types/user'
import { QueryKey } from '~/types/query-key'
import { useQuery } from './use-query'

export function useProfile() {
  const accessToken = useAuthStore((state) => state.accessToken)
  const user = useSessionStore((state) => state.user)
  const setUser = useSessionStore((state) => state.setUser)

  const query = useQuery<{ user: User }>({
    queryKey: QueryKey.PROFILE,
    options: {
      enabled: !!accessToken && !user,
    },
    onSuccess: (data) => {
      setUser(data.user)
    },
  })

  return query
}
